<template>
  <div class="partner">    
    <div v-if="hasData" class="card-partner"
      :style="{background: `url(/img/onboard-driver/card-partner.svg)`,
        backgroundRepeat: `no-repeat`}">

      <div class="info-partner">
        <p>{{ data.name }} </p>
        <div class="is-flex">
          <span>{{ data.relationship }}</span>
          <img src="/img/icons/dot.svg" alt width="5" height="5" class="dot" />
          <span>{{ data.year_of_birth }}</span>
        </div>
        <div class="is-flex">
          <img src="/img/icons/cellphone.svg" width="18" height="18" alt />
          <span>{{ data.phone }}</span>
        </div>
        <div class="is-flex">
          <img src="/img/icons/vali.svg" width="18" height="18" alt />
          <span>{{ data.occupation }}</span>
        </div>
      </div>
    </div>
    <div class="icon-partner" v-else>
      <img src="/img/icons/partner.svg" />
      <p>{{ $t(`driver_onboarding.profile.relative.relative_${index+1}`) }}</p>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex"

export default {
  data() {
    return {};
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    data: {
      type: Object
    }
  },
  computed : {
    ...mapGetters(['formData']),
    hasData () {
      return !!(this.data 
        && this.data.name
        && this.data.relationship
        && this.data.year_of_birth
        && this.data.phone
        && this.data.occupation)
    }
  },

};
</script>
<style lang="scss" scoped>
.partner {
  min-width: 120px;
  text-align: center;
  cursor: pointer;

  .card-partner {
    text-align: left;
    width: 220px;
    height: 122px;
    .info-partner {
      padding: 15px;
      p {
        font-size: 14px;
        color: #ff8200;
        font-weight: 500;
        margin: 0;
      }
      .is-flex {
        font-size: 12px;
        font-weight: bold;
        color: #7a8189;
        margin: 5px 0;
        img.dot {
          margin: 0 8px;
        }
        img {
          margin-right: 5px;
        }
      }
    }
  }

  .icon-partner {
    width: 120px;
    p {
      font-size: 14px;
      color: #ff8200;
    }
  }
}
</style>
